import PropTypes from 'prop-types'
import Validator from 'utils/Validator'

export const AuthenticationInputPropTypes = {
  // common property
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  type: PropTypes.string.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  embedErrorsInfo: PropTypes.bool,
  callback: PropTypes.func,
  placeholder: PropTypes.string,
  validations: PropTypes.arrayOf((propValue, key, componentName, location, propFullName) => {
    if (!Validator.rules().includes(propValue[key])) {
      return new Error(`Invalid prop ${propFullName} supplied to` +
        ` \`${componentName}\`. Validation for \`${propValue[key]}\` does not exist.`)
    }
    return true
  }),
  onChange: PropTypes.func,

  // only for select property (select2, radio, and buttonSelect tag)
  selectOptions: PropTypes.array,
  selectAjaxSource: PropTypes.string,
}
